export default "__VITE_ASSET__BdyGx8FW__"